import React from "react";
import login from "../../Assets/brand/login.svg";

const ForgotIllustration: React.FC = () => {
  return (
    <div className="max-w-md" id="forgot-illustration-container">
      <img
        id="forgot-password-illustration-image"
        src={login}
        alt="Forgot password illustration"
        className="w-full h-auto"
      />
    </div>
  );
};

export default ForgotIllustration;
